(function ($) {

    function OffsetTop(mastheadHeight) {
        $('#content.site-content').css({'padding-top': mastheadHeight + 'px'});
        if ($('.main-navigation').hasClass('toggled')) {
            $('.menu-container').css({'top': mastheadHeight + 'px'});
        }
        // Enquiry Form
        $('.enquiry-form').css({'top': mastheadHeight + 'px'});

        // Subscription
        $('.ppir-subscription').css({'top': mastheadHeight + 'px'});
    }

    function addParamToUrl(action, param, value) {

        var loc = window.location;

        // check if param exists
        var result = new RegExp(param + "=([^&]*)", "i").exec(loc.search);
        result = result && result[1] || "";

        if (action == 'add') {

            // added seperately to append ? before params
            var url = loc.protocol + '//' + loc.host + loc.pathname + loc.search;

            // param doesn't exist in url, add it
            if (result == '') {
                //doesn't have any params
                if (loc.search == '') {
                    url += "?" + param + '=' + value;
                }
                else {
                    url += "&" + param + '=' + value;
                }
            }
        }
        else {
            var loc = window.location;
            var url = loc.protocol + '//' + loc.host + loc.pathname;
        }


        // rewrite the url
        window.history.pushState({path: url}, '', url);
    };

    function getUrlParameter(sParam) {

        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    function languageSwitchers(_width) {
        if (_width > 992) {
            $('.language-switchers').insertAfter('.site-branding');
        }
        else {
            $('.language-switchers').insertAfter('.primary-menu-cta');
        }
    }

    function preventMotion(event) {
        window.scrollTo(0, 0);
        event.preventDefault();
        event.stopPropagation();
    }

    $(document).ready(function () {

        var subscription = getUrlParameter('subscription');
        var mastheadHeight = $('header#masthead').outerHeight();

        OffsetTop(mastheadHeight);

        $('.award-name').matchHeight();

        if ($('.feature-box').length) {

            $('.feature-box').each(function () {

                var _this = $(this);
                var _image = _this.find('.wp-block-column.image img').attr('src');
                _this.find('.wp-block-column.image').css({'background-image': 'url(' + _image + ')'});
            });
        }

        if ($('.banner-cta').length) {

            $('.banner-cta').each(function () {
                var _this = $(this);
                var image = _this.find('.wp-block-media-text__media img').attr('src');
                _this.find('.wp-block-media-text__content').css({'background-image': 'url(' + image + ')'});
            });
        }

        if ($('.feature-press-slider').length) {

            if ($('.feature-press-item').length > 3) {

                $('.feature-press-slider').addClass('centerMode');

                $('.feature-press-slider').slick({
                    dots: true,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: 40,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                centerMode: true,
                                centerPadding: 20,
                            }
                        }
                    ]
                });
            }
            else {

                $('.feature-press-slider').addClass('customCenter');

                $('.feature-press-slider').slick({
                    dots: true,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });
            }
        }

        // Add Closed Button On Enquire Form
        if ($('.enquiry-form').length) {
            $('<div class="btn-close"></div>').appendTo('.enquiry-form');
        }

        // Open Enquire Form
        $('.btn-enquiries').on('click', function () {
            $('.enquiry-form').stop(true, true).fadeIn(300).addClass('toggled');
            // window.addEventListener('scroll', preventMotion, false);
            // window.addEventListener('touchmove', preventMotion, false);
        });

        // Close Enquire Form
        $('body').on('click', '.enquiry-form .btn-close', function () {
            $('.enquiry-form').stop(true, true).fadeOut(300).removeClass('toggled');
            // window.removeEventListener('scroll', preventMotion, false);
            // window.removeEventListener('touchmove', preventMotion, false);
        });

        // Set Today As Default Value
        if ($('.wpcf7-form').length) {
            var today = new Date().toISOString().split('T')[0];
            $('input[type=date]').val(today);

        }

        // Submit Enquire Form
        $('.enquiry-form-submit').on('click', function () {
            $(this).closest($('.wpcf7-form')).submit();
        });

        // Open Subscription Form
        $('.subscribe').on('click', function () {
            if ($('.dunch-popup').length) {
                $('.dunch-popup').stop(true, true).fadeIn(300).addClass('toggled');
            }
            else {
                $('.ppir-subscription').stop(true, true).fadeIn(300).addClass('toggled');
            }
            addParamToUrl('add', 'subscription', 'open');
        });

        if (subscription) {
            $('.subscribe').trigger('click');
        }

        if ($('.home').length && $('.dunch-popup').length && $('.dunch-popup').attr('data-auto-popup') === 1) {
            $('.subscribe').trigger('click');
        }

        if($('.home').length && $('.ppir-subscription').length && $('.ppir-subscription').attr('data-auto-popup') === 1) {
            $('.subscribe').trigger('click');
        }

        // Submit Subscription Form
        $('.subscription-sbumit').on('click', function () {
            $(this).closest($('.mc4wp-form')).submit();
        });

        // Close Dunch Popup
        $('.dunch-popup__close').on('click', function () {
            $('.dunch-popup').stop(true, true).fadeOut(300).removeClass('toggled');
        });

        // Body click
        $('body').on('click', function (e) {

            // Close Enquiry Form
            if ($('.enquiry-form').hasClass('toggled')) {

                if (
                    $(e.target).is('.wp-block-column:not(.form)')
                    ||
                    (
                        $(e.target).is('.enquiry-form')
                        &&
                        !$(e.target).is('.btn-enquiries')
                    )
                ) {
                    $('.enquiry-form').stop(true, true).fadeOut(300).removeClass('toggled');
                    // window.removeEventListener('scroll', preventMotion, false);
                    // window.removeEventListener('touchmove', preventMotion, false);
                }
            }

            // Close Subscription Form
            if ($('.ppir-subscription').hasClass('toggled')) {

                if (
                    $(e.target).is('.ppir-subscription')
                    &&
                    !$(e.target).is('.subscribe')
                ) {

                    $('.ppir-subscription').stop(true, true).fadeOut(300).removeClass('toggled');
                    addParamToUrl('clear', '', '');
                }
            }

            // Close Dunch Popup
            if ($('.dunch-popup').hasClass('toggled')) {

                if (
                    $(e.target).is('.dunch-popup')
                    &&
                    !$(e.target).is('.subscribe')
                ) {

                    $('.dunch-popup').stop(true, true).fadeOut(300).removeClass('toggled');
                    addParamToUrl('clear', '', '');
                }
            }
        });
    });

    $(window).load(function () {

        var _width = window.innerWidth;
        var mastheadHeight = $('header#masthead').outerHeight();

        languageSwitchers(_width);

        $('.scroll-for-more').on('click', function () {
            $("html, body").animate({
                scrollTop: $('.entry-content').offset().top - mastheadHeight - 30
            }, 1000);
        });

        // Gallery Masonry
        if ($('.attachments-gallery').length) {

            function galleryIsotope() {

                var $container = $('.attachments-gallery__items').isotope({
                    itemSelector: '.attachments-gallery__item',
                    columnWidth: '.attachments-gallery__item',
                    percentPosition: true,
                    layoutMode: 'masonry',
                });

                var initShow = 15;
                var counter = initShow;
                var iso = $container.data('isotope');

                var type = getUrlParameter('type');

                if (type) {
                    $('.attachments-gallery__item').not('.' + type).find('a').attr('data-fancybox', '');
                    $('.attachments-gallery__items').isotope({filter: '.' + type});
                }

                galleryLoadMore(initShow);

                function galleryLoadMore(toShow) {

                    $container.find('.hidden').removeClass('hidden');

                    var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
                        return item.element;
                    });
                    $(hiddenElems).addClass('hidden');
                    $container.isotope('layout');

                    //when no more to load, hide show more button
                    if (hiddenElems.length == 0) {
                        jQuery('.attachments-gallery__load-more').hide();
                    } else {
                        jQuery('.attachments-gallery__load-more').show();
                    }
                    ;
                }

                $('.attachment-term').change(function () {

                    var length = 0;
                    var filters = [];

                    $('.attachments-gallery__item').not(filters).find('a').attr('data-fancybox', 'images');

                    $('.attachment-term').each(function () {

                        if ($(this).is(":checked")) {
                            length++;
                            filters.push($(this).parents('li').attr('data-filter'));
                        }
                    });

                    if (length == $('.attachment-term').length || length == 0) {
                        filters = '*';
                    }
                    else {
                        filters = filters.join(', ');
                        $('.attachments-gallery__item').not(filters).find('a').attr('data-fancybox', '');
                    }
                    $('.attachments-gallery__items').isotope({filter: filters});

                    galleryLoadMore(initShow);
                });

                $('.attachments-gallery__load-more').click(function () {
                    if ($('.attachment-term').data('clicked')) {
                        //when filter button clicked, set initial value for counter
                        counter = initShow;
                        $('.attachment-term').data('clicked', false);
                    } else {
                        counter = counter;
                    }
                    ;

                    counter = counter + initShow;

                    galleryLoadMore(counter);
                });
            }

            var lazyLoadInstance = new LazyLoad({
                elements_selector: ".attachments-gallery__item img",
                callback_loaded: function (el) {
                    galleryIsotope();
                }
            });

        }

        $(window).resize(function () {
            _width = window.innerWidth;
            mastheadHeight = $('header#masthead').outerHeight();

            OffsetTop(mastheadHeight);
            languageSwitchers(_width);
        });
    });

    $(window).scroll(function () {
        var mastheadHeight = $('header#masthead').outerHeight();
        OffsetTop(mastheadHeight);
    });


    // Global site tag (gtag.js) - Google Analytics
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', 'UA-135375317-1');

})(jQuery);